<div class="bg-white rounded-xl border border-slate-200 p-5 sm:p-6 hover:shadow-md transition-shadow duration-150">
  <div class="mb-5">
    <h2 class="text-xl font-bold text-slate-900 flex items-center gap-2">
      <i
        [ngClass]="{
          'bi bi-bar-chart text-accent-600': type() === 'bar',
          'bi bi-pie-chart text-emerald-600': type() === 'pie'
        }"
      ></i>
      {{ titulo() }}
    </h2>
  </div>
  <div
    class="h-full bg-slate-50/50 rounded-lg flex items-center justify-center border-2 border-dashed border-slate-200"
  >
    @if (data().datasets.length > 0) {
      <canvas #chartCanvas class="w-full h-full" role="img"></canvas>
    } @else {
      <div class="text-center">
        @switch (type()) {
          @case ('bar') {
            <i class="bi bi-graph-up text-4xl text-slate-400 mb-3 block"></i>
            <p class="text-slate-500 font-medium">Gráfico de barras</p>
            <p class="text-slate-400 text-sm">(Facturas, Boletas, Notas de Venta)</p>
          }
          @case ('pie') {
            <i class="bi bi-pie-chart-fill text-4xl text-slate-400 mb-3 block"></i>
            <p class="text-slate-500 font-medium">Gráfico circular</p>
            <p class="text-slate-400 text-sm">(Estado de ventas)</p>
          }
          @case ('line') {
            <i class="bi bi-graph-up-arrow text-4xl text-slate-400 mb-3 block"></i>
            <p class="text-slate-500 font-medium">Gráfico de líneas</p>
            <p class="text-slate-400 text-sm">(Ventas en el tiempo)</p>
          }
        }
      </div>
    }
  </div>
  @if (showLegend() === true) {
    <div class="grid grid-cols-3 gap-2 mt-6">
      @for (item of data().datasets; let i = $index; track i) {
        @for (itemData of item.data; let j = $index; track j) {
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 rounded" [style.backgroundColor]="item.backgroundColor.at(j)"></div>
            <span class="text-sm text-slate-700"
              >{{ data().labels?.at(j) }}:
              {{ tipoData() === 'dinero' ? (itemData | currency: 'PEN' : 'S/. ') : itemData }}</span
            >
          </div>
        }
      } @empty {
        <p class="text-slate-500 text-sm col-span-3 text-center">No hay datos disponibles</p>
      }
    </div>
  }
</div>